import React from 'react';
import {Field, Fields, reduxForm} from 'redux-form';
import ShowContactPerson from "../contact-person/ShowContactPerson";
import SubmitButton from "../common/SubmitButton";
import MachineDates from "./MachineDates";
import MachineRadioGroup from "./MachineRadioGroup";
import ValidatedInputField from '../common/form/ValidatedInputField'
import BlockFormWrapper from "../common/form/BlockFormWrapper";
import VideoUploadRedux from '../VideoUploadRedux';
import FileUpload from '../files/FileUpload';
import {machinesValidator} from "./MachinesValidator";
import Price from "../common/Price";
import machineSellTypes from "../../common/machineSellTypes";
import "../../../scss/machine.scss";
import { injectIntl } from 'react-intl';
import {messages} from  '../common/Translations';
import MultistepSelectFormAdapter from '../common/MultistepSelectFormAdapter';
import DropDownOptions from '../helpers/DropDownOptions';
import ReactSelect from '../common/ReactSelect';
import RteEditor from "../common/form/RteEditor";
import afterSubmitFail from '../common/form/focusAfterSubmitFail';
import ResetButton from "../common/ResetButton";

let MachineForm = props => {
    const {
        categories,
        handleSubmit,
        handleModalClick,
        handleReset,
        contactPersons,
        isUpdate,
        initialValues,
        showPreviewModal,
        touch,
        intl
    } = props;

    let showMachinePreviewModal = function ()  {
        Object.keys(initialValues).forEach((fieldName) => touch(fieldName));
        showPreviewModal();
    };

    let imageSizeLimit = (MAX_IMAGE_SIZE > 1) ? MAX_IMAGE_SIZE - 1 : 1;
    let fileSizeLimit = (MAX_FILE_SIZE > 1) ? MAX_FILE_SIZE - 1 : 1;

    return (
        <form onSubmit={handleSubmit} noValidate={true}>

            <div className="row">
                <div className="col-12">
                    <BlockFormWrapper title={intl.formatMessage(messages.data)}>


                        <div className="form-group row">
                            <label className="col-sm-2 col-form-label">
                                <b>{intl.formatMessage(messages.contactPerson)}</b>
                                {' ' + intl.formatMessage(messages.optional)}
                            </label>
                            <div className="col-sm-10">
                                <Field
                                    type="select"
                                    name="contactPersonId"
                                    component={ReactSelect}
                                    options={DropDownOptions.getOptions(contactPersons, 'id', 'name')}
                                    placeholder={intl.formatMessage(messages.contactPersonSelect)}
                                />
                                <Field
                                    type="button"
                                    name="showModal"
                                    onChage={handleModalClick}
                                    component={ShowContactPerson}
                                    props={{
                                        handleModalClick: handleModalClick,
                                        text: intl.formatMessage(messages.machineFormContactPersonDescription),
                                    }}
                                />
                            </div>
                        </div>
                        <div className="form-group row">
                            <label className="col-sm-2 col-form-label">
                                <b>{intl.formatMessage(messages.statistic)}</b>
                                {' ' + intl.formatMessage(messages.optional)}
                            </label>
                            <div className="col-sm-10">
                                <label className="custom-control custom-checkbox">
                                    <Field
                                        type="checkbox"
                                        name="isStatisticAllowed"
                                        component="input"
                                        className="custom-control-input"
                                    />
                                    <span className="custom-control-indicator"> </span>
                                    <span className="custom-control-description">
                                        {intl.formatMessage(messages.sendStatisticToContactPerson)}
                                    </span>
                                </label>
                            </div>
                        </div>
                        <div className="form-group row">
                            <label className="col-sm-2 col-form-label">
                                <b>{intl.formatMessage(messages.comments)}</b>
                                {' ' + intl.formatMessage(messages.optional)}
                            </label>
                            <div className="col-sm-10">
                                <label className="custom-control custom-checkbox">
                                    <Field
                                        type="checkbox"
                                        name="isCommentsAllowed"
                                        component="input"
                                        className="custom-control-input"
                                    />
                                    <span className="custom-control-indicator"> </span>
                                    <span className="custom-control-description">
                                        {intl.formatMessage(messages.machinesAllowVisitorsToComment)}
                                    </span>
                                </label>
                            </div>
                        </div>
                        <Fields
                            type="datePicker"
                            names={['startDate', 'endDate']}
                            component={MachineDates}
                        />
                        <Field
                            name="categoryIds"
                            component={MultistepSelectFormAdapter}
                            data={categories}
                        />
                        <Field
                            name="sellType"
                            isUpdate={isUpdate}
                            label={intl.formatMessage(messages.machineBuySellRent)}
                            component={MachineRadioGroup}
                            options={
                                Object.keys(machineSellTypes).map((value) => {
                                    return {
                                        value: value,
                                        title: machineSellTypes[value]
                                    };
                                })
                            }
                        />
                        <Field
                            name="isUsed"
                            isUpdate={isUpdate}
                            label={intl.formatMessage(messages.machineNewOrUsed)}
                            component={MachineRadioGroup}
                            options={
                                [
                                    {title: intl.formatMessage(messages.new), value: 'new'},
                                    {title: intl.formatMessage(messages.used), value: 'used'}
                                ]
                            }
                        />
                        <Price/>


                    </BlockFormWrapper>

                    <BlockFormWrapper title={intl.formatMessage(messages.files)}>
                        <div className="form-group row">
                            <label className="col-sm-2 col-form-label">
                                <b>{intl.formatMessage(messages.description)}</b>
                                {intl.formatMessage(messages.optional)}
                                <small className="form-text text-muted">
                                    {`${intl.formatMessage(messages.filesMaxSize)} ${imageSizeLimit} MB.`}
                                </small>
                            </label>
                            <div className="col-sm-10">
                                <Fields
                                    type="file"
                                    names={[
                                        'images',
                                        'defaultImages',
                                        'defaultImageIds',
                                    ]}
                                    component={FileUpload}
                                    props={{
                                        postUrl: 'api/privateV1/machines/validate-images',
                                        type: 'image',
                                    }}
                                />
                            </div>
                        </div>
                        <div className="form-group row">
                            <label className="col-sm-2 col-form-label">
                                <b>{intl.formatMessage(messages.catalogs)}</b>
                                {intl.formatMessage(messages.optional)}
                                <small className="form-text text-muted">
                                    {`${intl.formatMessage(messages.filesMaxSize)} ${fileSizeLimit} MB.`}
                                </small>
                            </label>
                            <div className="col-sm-10">
                                <Fields
                                    type="file"
                                    names={[
                                        'files',
                                        'defaultFiles',
                                        'defaultFileIds',
                                    ]}
                                    component={FileUpload}
                                    props={{
                                        postUrl: 'api/privateV1/machines/validate-files',
                                        type: 'file',
                                    }}
                                />
                            </div>
                        </div>
                        <Fields
                            type="text"
                            names={[
                                'youtubeId',
                                'vimeoId',
                                'vimeoName',
                                'vimeoDescription',
                            ]}
                            component={VideoUploadRedux}
                        />
                    </BlockFormWrapper>

                    <BlockFormWrapper title={intl.formatMessage(messages.text)}>
                        <Field
                            className="form-control"
                            name="heading"
                            label={intl.formatMessage(messages.heading)}
                            component={ValidatedInputField}
                        >
                        </Field>
                        <Field
                            type="text"
                            name="description"
                            component={RteEditor}
                            placeholder={intl.formatMessage(messages.descriptionPlaceholder)}
                            isUpdate={isUpdate}
                        />
                        <Field
                            className="form-control"
                            name="producer"
                            label={<span>
                                <b>{intl.formatMessage(messages.machineProducer)}</b>
                                {' ' +intl.formatMessage(messages.optional)}
                                </span>}
                            component={ValidatedInputField}
                            placeholder=""
                        >
                        </Field>
                        <Field
                            className="form-control"
                            name="model"
                            label={<span>
                                <b>{intl.formatMessage(messages.machineModel)}</b>
                                {' ' + intl.formatMessage(messages.optional)}
                                </span>}
                            component={ValidatedInputField}
                            placeholder=""
                        >
                        </Field>
                        <div className="form-group row">
                            <label className="col-sm-2 col-form-label">
                                <b>{intl.formatMessage(messages.machineYear)}</b>
                                {' ' +intl.formatMessage(messages.optional)}</label>
                            <div className="col-sm-10">
                                <Field
                                    className="form-control"
                                    name="year"
                                    component="input"
                                    type='number'
                                    min='1960'
                                >
                                </Field>
                            </div>
                        </div>
                        <Field
                            className="form-control"
                            name="referenceNumber"
                            label={<span>
                                <b>{intl.formatMessage(messages.machineReferenceNumber)}</b>
                                {' ' + intl.formatMessage(messages.optional)}</span>}
                            component={ValidatedInputField}
                            placeholder=""
                        >
                        </Field>

                    </BlockFormWrapper>

                    <hr/>
                    <div className="form-group row">
                        <div className="col-sm-12">
                            <div className="offset-sm-2">
                                <div className="machine-button">
                                    <SubmitButton isUpdate={isUpdate}/>
                                    <ResetButton onClick={handleReset}/>
                                    <button
                                        type="button"
                                        className="btn btn-secondary waves-effect waves-light ml-3"
                                        onClick={showMachinePreviewModal}
                                    >
                                        {intl.formatMessage(messages.browse)}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </form>
    )
};

MachineForm = reduxForm({
    form: 'machine',
    validate: machinesValidator,
    onSubmitFail: afterSubmitFail
})(MachineForm);

export default injectIntl(MachineForm);


// WEBPACK FOOTER //
// ./web/src/components/machines/MachineForm.jsx